import { useState } from "react";
export const useNewsDetailState = () => {
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  return {
    news, setNews, loading, setLoading, error, setError
  }
};
